import React from 'react'
import ParcelDetailsByTms from '../parcels/components/ParcelDetailsByTms'


const DetailsByTmsPanel: React.FC = () => {
  return (
    <aside id="sidebar">
      <section>
        <h3>Details</h3>
        <h4>Parcel</h4>
        <ParcelDetailsByTms />
      </section>
    </aside>
  )
}

export default DetailsByTmsPanel